<template>
  <div class="Details">
    <Head :Catedetails="catemessage" :pages="1"></Head>
    <div class="contentbox">
      <div class="left">
        <div class="content-title"></div>
        <div class="content" v-html="list.post_content"></div>
      </div>
      <div class="tuijian">
        <div
          class="item"
          v-for="(item, index) in tuilist"
          :key="index"
          @click="getdata(item.id)"
        >
          <img
            :src="'http://www.xinhuoa.com:2363/upload/' + item.more.thumbnail"
            alt=""
          />
          <div class="title">{{ item.post_title }}</div>
        </div>
      </div>
    </div>
    <Gohome></Gohome>
  </div>
</template>

<script>
import Head from '../../components/Head.vue'
import Gohome from '../../components/Gohome.vue'
import { subCatelist, Recommenddata } from '@/api/Home'
import { Detailsdata } from '@/api/Product'
export default {
  components: { Head, Gohome },
  data() {
    return {
      id: null,
      cid: null,
      cie: null,
      pid: null,
      key: null,
      tuilist: [],
      catemessage: null,
      navlist: [],
      list: null,
    }
  },
  created() {
    this.catedata()
    this.getdata()
  },
  mounted() {},
  methods: {
    async catedata() {
      this.cid = this.common.urlget('cid')
      this.key = this.common.urlget('key')
      // alert(this.cid)

      const { data: res } = await subCatelist(this.cid)
      console.log(res)
      if (res.code === 1) {
        // console.log(res.data.categories[0].id)
        this.navlist = res.data.categories
        this.catemessage = this.navlist[this.key]
        this.pid = this.navlist[this.key].id
        this.recommendlist()
        // console.log(this.navlist[this.key].id)
        // this.pid = res.data.categories[0].id
        // this.getlistdata()
      }
    },
    async getdata(ids) {
      if (ids) {
        this.id = ids
      } else {
        this.id = this.common.urlget('id')
      }

      let { data: res } = await Detailsdata(this.id)
      if (res.code === 1) {
        this.list = res.data
        this.recommendlist()
        // console.log(this.list.post_content)
      }
    },
    async recommendlist() {
      let { data: res } = await Recommenddata(this.pid)
      // console.log(res)
      if (res.code == 1) {
        // res.data.data.forEach((e) => {
        //   console.log(e)
        // })
        let arr = res.data.data
        this.tuilist = arr.filter((item) => item.id != this.id)
        // console.log(arr)
        // this.tuilist = res.data.data

        // console.log(this.tuilist)
      }
    },
  },
}
</script>
 
<style lang="less" scoped>
// /deep/ .ue-table-interlace-color-single {
//   height: 0.3rem;
// }
.Details {
  cursor: pointer;
  .contentbox {
    margin-top: 0.99rem;
    display: flex;
    height: auto;
    padding: 0 7.58rem;
    background: #f5f5f5;
    .left {
      .content-title {
        width: 18.6rem;
        height: 1rem;
        background: #ffffff;
        position: relative;
        &::before {
          position: absolute;
          top: 0;
          content: '商品详情';
          width: 3.32rem;
          height: 1rem;
          line-height: 1rem;
          background: #009269;
          text-align: center;
          font-size: 0.35rem;
          font-family: OPPOSans;
          font-weight: bold;
          color: #ffffff;
          // border: 0rem solid #0b0306;
        }
      }
      .content {
        box-sizing: border-box;
        width: 18.6rem;
        overflow: hidden;
        background: #ffffff;
        // background: #ccc;
        // background: #fff;
        color: black;
        height: auto;
        padding: 0.76rem;
        table {
          tbody {
            tr {
              td {
                height: 0.3rem;
              }
            }
          }
        }
      }
    }
    .tuijian {
      //   position: absolute;
      box-sizing: border-box;
      padding-top: 1rem;
      width: 3.77rem;
      height: 18.2rem;
      margin-left: 0.53rem;
      position: relative;
      &::before {
        position: absolute;
        top: 0;
        content: '';
        width: 3.47rem;
        height: 0.36rem;
        line-height: 1rem;
        background: #009269;
        text-align: center;
        font-size: 0.35rem;
        font-family: OPPOSans;
        font-weight: bold;
        color: #ffffff;
        background: url('../../../static/images/——推荐商品——.png') no-repeat;
        background-size: 100% 100%;
      }
      .item {
        width: 3.77rem;
        height: 3.84rem;
        // background: red;
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 0.6rem;
        .title {
          position: absolute;
          bottom: 0;
          width: 3.77rem;
          text-align: center;
          height: 0.63rem;
          line-height: 0.63rem;
          background: #333333;
          opacity: 0.69;
          font-size: 0.26rem;
          font-family: OPPOSans;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Product/Details.vue